var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "prop-types", "classnames"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("prop-types"), require("classnames"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames);
    global.Link = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _propTypes, _classnames) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _classnames = _interopRequireDefault(_classnames);

  var Link = function Link(_ref) {
    var className = _ref.className,
        id = _ref.id,
        label = _ref.label,
        _onClick = _ref.onClick,
        selected = _ref.selected,
        url = _ref.url;
    return /*#__PURE__*/_react.default.createElement("li", {
      key: "link-".concat(id),
      className: "next-links-list__item"
    }, /*#__PURE__*/_react.default.createElement("a", {
      className: (0, _classnames.default)('next-links-list__link', {
        'is-selected': selected
      }, className),
      href: url,
      onClick: function onClick(event) {
        return _onClick(id, event);
      }
    }, label));
  };

  Link.propTypes = {
    className: _propTypes.default.string,
    id: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    onClick: _propTypes.default.func.isRequired,
    selected: _propTypes.default.bool,
    url: _propTypes.default.string
  };
  Link.defaultProps = {
    className: '',
    label: '',
    onClick: function onClick() {
      return null;
    },
    selected: false
  };
  var _default = Link;
  _exports.default = _default;
});